import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">
          读者热评
        </h2>
        <p className="text-sm text-foreground-500 mb-8">看看大家都在讨论什么</p>
        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <img
                  src={comment.avatar}
                  alt={comment.name}
                  className="w-10 h-10 rounded-full object-cover flex-shrink-0"
                  width="80"
                  height="80"
                />
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1 flex-wrap">
                    <span className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{comment.name}</span>
                    <span className="text-xs text-foreground-400">{comment.time}</span>
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-3">{comment.content}</p>
                  <div className="flex items-center gap-4 text-xs text-foreground-400">
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-thumb-up-line"></i>
                      <span>{comment.likes.toLocaleString()}</span>
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-chat-1-line"></i>
                      回复
                    </button>
                    <button className="flex items-center gap-1 hover:text-primary-500 transition-colors cursor-pointer whitespace-nowrap">
                      <i className="ri-share-forward-line"></i>
                      分享
                    </button>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}